import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  addFormSetChildForm,
  clearForm,
  fetchFormData,
  postFormData,
  setFormData,
  setFormStep,
  updateFormValue,
} from 'common/components/form/actions';

export const getChildFormByPrefix = (form, prefix) =>
  form.formset.forms.find((child) => child.prefix === prefix);

// Wrapper func to identify which form gets mapped to props
const mapStateToProps = (state, ownProps) => {
  const {formId, parentForm} = ownProps;
  const prefix = ownProps.form?.prefix;
  const {form, isLoading, isSaving, error} = state[formId];
  if (form) {
    if (parentForm) {
      return {
        ...ownProps,
        isLoading,
        isSaving,
        error,
        form: getChildFormByPrefix(form, prefix),
      };
    }
    return {
      ...ownProps,
      isLoading,
      isSaving,
      error,
      form,
    };
  }

  return {
    ...ownProps,
    isLoading,
    isSaving,
    error,
  };
};

// Passing this map to `connect` causes these action creator
// methods to be passed as props to Form, and the returned actions
// are dispatched automatically.
const mapDispatchToProps = {
  addFormSetChildForm,
  clearForm,
  fetchFormData,
  postFormData,
  setFormData,
  setFormStep,
  updateFormValue,
};

// connectToForm
//
// Wrapper func to connect any component that needs form data or actions.
// This includes Form, and FormFieldProvider, but may include other components
// that need the form's data or want to dispatch form actions.
//
export const connectToForm = (Component) => {
  const Container = connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
  })(Component);

  Container.propTypes = {
    formId: PropTypes.string.isRequired,
  };

  return Container;
};

export const formPropTypes = {
  form: PropTypes.object,
  formId: PropTypes.string,
  url: PropTypes.string,
};

export const FormThemeEnum = {
  LEGACY: 'legacy',
  FUSION: 'fusion',
};

export const normalizeSelectOptions = (choices) =>
  choices.map((choice) => ({
    ...choice,
    label: choice.label || choice.display || choice.displayName,
    value:
      typeof choice.value === 'number'
        ? choice.value
        : choice.value || choice.id,
  }));
